import React, { useState, FC} from 'react';
import { Pie } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend, 
} from 'chart.js';
import { CostServicesProps } from '../constants/types';
import { useCostServicesData } from '../hooks/useCostServicesData';
import { getPieChartData } from '../utils/getCostServiceData';
import { getPieChartOptions} from '../utils/getCostServicesOptions';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const CostServices: FC<CostServicesProps> = ({ token }) => {
  const [clickedSegment, setClickedSegment] = useState<number|null>(null); 
  const chartData = useCostServicesData(token);

  if (!chartData) 
  {
    return <div className="text-center text-gray-500 p-4">No data available</div>;
  }

  const data = getPieChartData(chartData, clickedSegment);
  const options = getPieChartOptions(chartData, clickedSegment, setClickedSegment);

  return (
    <div className="relative">
      <button className="group absolute bg-none border-none cursor-pointer z-10 top-2 right-6 text-[#2d2d2d]">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-for="helpIcontip" data-tip="" className="help-icon">
          <path d="M10.417 7.914h.75v-.75h-.75v.75zM18 10a8 8 0 01-8 8v1.5a9.5 9.5 0 009.5-9.5H18zm-8 8a8 8 0 01-8-8H.5a9.5 9.5 0 009.5 9.5V18zm-8-8a8 8 0 018-8V.5A9.5 9.5 0 00.5 10H2zm8-8a8 8 0 018 8h1.5A9.5 9.5 0 0010 .5V2zm1.167 13.208V7.914h-1.5v7.294h1.5zm-.75-8.044H8.333v1.5h2.084v-1.5zm-2.084 8.794H12.5v-1.5H8.333v1.5zM9.38 5.542h2.073v-1.5H9.38v1.5z" fill="#899093"></path>
        </svg>
        <div className="absolute top-8 bg-gray-800 text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-50 w-[140px] h-auto text-center">
          In AWS, each service can run multiple tasks for high availability
        </div>
      </button>
      <Pie data={data} options={options} />
    </div>
  );
};

export default CostServices;


